import { render } from "./FAQ.vue?vue&type=template&id=968502b8"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=968502b8&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__